import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickProbeModel from '@/components/brick_probe_model.vue'
import SummaryResult from '@/components/summary_result.vue'
import Vue from 'vue'

Vue.component('SummaryResult', SummaryResult)

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-rectangle-portrait', 'text-purple']
infos.front_classes = ['fas', 'fa-thermometer-half', 'text-white']
// infos.front_classes = ['fas', 'fa-temperature-low', 'text-white']
// infos.front_classes = []
infos.name = 'probemodel'
infos.associated_class_name = 'AutomlProbeModel'
infos.editing_component_name = 'BricProbeModel'
infos.editing_component = BrickProbeModel
infos.summary_component_name = 'SummaryResult'
infos.summary_component = SummaryResult
infos.descriptions = {
	en: {
		short_tooltip_description: 'Probes a model',
		full_tooltip_description: 'Probes a model',
		navbar_name: 'Column probe',
	},
	fr: {
		short_tooltip_description: 'Sonde de modèle',
		full_tooltip_description: 'Sonde de modèle',
		navbar_name: 'Sonde de modèle',
	},
}

infos.background_color = 'purple'

brick_registerer(infos)
